import { Link } from 'react-router-dom';
import LegalLayout from './LegalLayout';
import { OPERATOR } from './meta';

export default function Terms() {
  return (
    <LegalLayout title="利用規約" enacted={OPERATOR.effectiveDate}>
      <p>
        本利用規約（以下「本規約」）は、{OPERATOR.operatorName}
        （以下「運営者」）が提供するアニメーション共有サービス「{OPERATOR.serviceName}
        」（以下「本サービス」）の利用条件を定めるものです。本サービスを利用する方（以下「利用者」）は、本規約に同意のうえ本サービスを利用するものとします。
      </p>

      <h2>第1条（適用）</h2>
      <ol>
        <li>本規約は、本サービスの利用に関する運営者と利用者との間の一切の関係に適用されます。</li>
        <li>
          本規約は、民法第548条の2に定める定型約款に該当します。利用者は、本サービスの利用を開始した時点で本規約の個別条項に合意したものとみなされます。
        </li>
        <li>
          運営者が本サービス上に掲載するガイドライン・プライバシーポリシー・権利侵害の申告に関する案内等（以下「個別規定」）は、本規約の一部を構成します。本規約と個別規定が矛盾する場合は、個別規定が優先します。
        </li>
      </ol>

      <h2>第2条（定義）</h2>
      <ul>
        <li>
          <strong>投稿コンテンツ</strong>
          … 利用者が本サービスにアップロード・投稿する VRMA（VRM
          Animation）ファイル、サムネイル、タイトル、説明文、タグその他の情報の総称。
        </li>
        <li>
          <strong>アカウント</strong>
          … 本サービスを利用するために登録される利用者固有の識別情報。
        </li>
      </ul>

      <h2>第3条（アカウント登録）</h2>
      <ol>
        <li>
          本サービスの一部機能（アップロード、公開/非公開設定、お気に入り等）の利用にはアカウント登録が必要です。認証には Amazon Cognito
          を利用します。
        </li>
        <li>
          利用者は、正確かつ最新の情報を登録するものとし、登録情報に変更が生じた場合は速やかに更新するものとします。
        </li>
        <li>
          利用者は、自己の責任においてアカウントの認証情報を管理するものとし、第三者に利用させ、または貸与・譲渡してはなりません。
        </li>
      </ol>

      <h2>第4条（未成年者の利用）</h2>
      <ol>
        <li>
          未成年者が本サービスを利用する場合は、親権者その他の法定代理人の同意を得たうえで利用するものとします。
        </li>
        <li>
          法定代理人の同意を得て本サービスを利用した後に成年に達した場合、当該利用者は成年後に本サービスを利用した時点で、未成年者であった間の利用行為を追認したものとみなされます。
        </li>
      </ol>

      <h2>第5条（投稿コンテンツの権利とライセンス）</h2>
      <ol>
        <li>
          投稿コンテンツに関する著作権その他の知的財産権は、利用者または正当な権利者に帰属します。本規約は、これらの権利を運営者へ移転させるものではありません。
        </li>
        <li>
          利用者は運営者に対し、本サービスの提供・維持・改善・宣伝に必要な範囲で、投稿コンテンツを無償で複製・公衆送信・表示・変換（サムネイル生成・形式変換・配信のための技術的加工等）することができる、非独占的な利用を許諾するものとします。当該許諾には、Amazon
          CloudFront 等の CDN
          を通じた配信のために必要な技術的複製を含みます。
        </li>
        <li>
          利用者が投稿コンテンツを「非公開」に設定した場合、運営者は本サービスの提供・保管・技術的処理に必要な範囲を超えて当該コンテンツを利用しません。
        </li>
        <li>
          利用者は、投稿コンテンツについて、自らが投稿・公開する正当な権利を有していること、および第三者の権利を侵害していないことを保証するものとします。
        </li>
      </ol>

      <h2>第6条（禁止事項）</h2>
      <p>利用者は、本サービスの利用にあたり、次の各号の行為をしてはなりません。</p>
      <ol>
        <li>法令または公序良俗に違反する行為。</li>
        <li>
          第三者の著作権・商標権・肖像権・パブリシティ権・プライバシー・名誉その他の権利または利益を侵害する行為。
        </li>
        <li>
          権利者の許諾なく、他者が制作したモーション・キャラクター・アバターを流用・改変して投稿する行為。
        </li>
        <li>
          VRM/VRMA モデルやモーションに付された利用条件（ライセンス）に違反する態様で投稿・利用する行為。
        </li>
        <li>わいせつ、暴力的、差別的、その他他者に著しく不快感を与える情報を投稿する行為。</li>
        <li>
          コンピュータウイルス等の有害なプログラムを含むファイルの投稿、または本サービスのサーバー・ネットワークに過度の負荷をかける行為。
        </li>
        <li>本サービスの運営を妨害する行為、不正アクセス、リバースエンジニアリング等の行為。</li>
        <li>他者になりすます行為、または虚偽の情報を登録・投稿する行為。</li>
        <li>その他、運営者が不適切と合理的に判断する行為。</li>
      </ol>

      <h2>第7条（本サービスの停止・変更・終了）</h2>
      <ol>
        <li>
          運営者は、システムの保守、障害、天災、その他やむを得ない事由がある場合、利用者への事前通知なく本サービスの全部または一部の提供を停止・中断することができます。
        </li>
        <li>
          運営者は、相当な予告期間をもって本サービスの内容を変更し、または提供を終了することができます。ただし、緊急の場合はこの限りではありません。
        </li>
      </ol>

      <h2>第8条（投稿コンテンツの削除・利用制限）</h2>
      <ol>
        <li>
          運営者は、投稿コンテンツが本規約に違反すると判断した場合、または権利侵害の申告等により違反のおそれがあると判断した場合、事前の通知なく当該コンテンツの非表示・削除、アカウントの利用停止・登録抹消等の措置を講じることができます。
        </li>
        <li>
          権利侵害の申告および運営者の対応手続は、別途「権利侵害の申告」ページに定めるところによります。
        </li>
        <li>前各項の措置により利用者に生じた損害について、運営者は本規約第9条の範囲でのみ責任を負います。</li>
      </ol>

      <h2>第9条（免責）</h2>
      <ol>
        <li>
          運営者は、本サービスが利用者の特定の目的に適合すること、期待する機能・正確性・有用性を有すること、投稿コンテンツが第三者の権利を侵害しないこと、および本サービスが中断・エラー・不具合なく提供されることを保証しません。
        </li>
        <li>
          運営者は、本サービスに関して利用者に生じた損害について、運営者に故意または重過失がある場合を除き、責任を負いません。
        </li>
        <li>
          前項の規定にかかわらず、消費者契約法その他の強行法規により運営者の責任を免除できない場合、運営者は当該法令に従い責任を負います。この場合において運営者が損害賠償責任を負うときは、運営者に故意または重過失がある場合を除き、賠償の範囲は現実に発生した通常かつ直接の損害に限られます。
        </li>
        <li>
          利用者間または利用者と第三者との間で生じた紛争については、当該当事者間で解決するものとし、運営者は責任を負いません。
        </li>
      </ol>

      <h2>第10条（利用料金）</h2>
      <ol>
        <li>
          本サービスは、アニメーションの投稿・閲覧・お気に入り登録その他の一般利用者向け機能を含め、無料で提供されます。
        </li>
        <li>
          開発者向け API についても、月間 50,000 リクエストまでは無料で利用できます。
        </li>
        <li>
          月間の無料利用枠を超えて API を継続的に利用することを希望する利用者は、
          <Link to={OPERATOR.contactPath}>{OPERATOR.contactLabel}</Link>
          より運営者に連絡するものとし、その可否ならびに条件（料金の要否を含みます）は、運営者と当該利用者との間で個別に協議のうえ合意します。
        </li>
        <li>
          運営者は、相当な予告期間をもって前項までの無料利用枠その他の提供条件を変更することができます。既存の利用者に対し不利益となる変更を行う場合には、変更内容および効力発生日を、事前に本サービス上への掲示その他の適切な方法により通知します。
        </li>
      </ol>

      <h2>第11条（個人情報の取扱い）</h2>
      <p>
        運営者は、利用者の個人情報を、別途定める「プライバシーポリシー」に従って適切に取り扱います。
      </p>

      <h2>第12条（本規約の変更）</h2>
      <ol>
        <li>
          運営者は、民法第548条の4の規定に従い、（1）変更が利用者の一般の利益に適合する場合、または（2）変更が契約目的に反せず、かつ変更の必要性・内容の相当性等に照らして合理的な場合に、本規約を変更することができます。
        </li>
        <li>
          運営者は、本規約を変更する場合、変更後の内容および効力発生時期を、本サービス上への掲示その他の適切な方法により、あらかじめ周知します。
        </li>
      </ol>

      <h2>第13条（準拠法・管轄裁判所）</h2>
      <ol>
        <li>本規約の解釈・適用には日本法を準拠法とします。</li>
        <li>
          本サービスに関して運営者と利用者との間に紛争が生じた場合、{OPERATOR.jurisdiction}
          を第一審の専属的合意管轄裁判所とします。
        </li>
      </ol>

      <h2>第14条（分離可能性）</h2>
      <p>
        本規約のいずれかの条項が無効または執行不能と判断された場合であっても、残りの条項は引き続き完全に効力を有します。
      </p>

      <h2>第15条（お問い合わせ）</h2>
      <p>
        本規約に関するお問い合わせは、<Link to={OPERATOR.contactPath}>{OPERATOR.contactLabel}</Link>
        よりご連絡ください。
      </p>

      <p className="legal__meta">制定日: {OPERATOR.effectiveDate}</p>
    </LegalLayout>
  );
}
